<template>
    <div>
        <modalCom :width='width' :height='height'>
            <div slot="title">
                <slot name="title"></slot>
            </div>
            <div slot="serch" class="serch">
                <slot name="serch"></slot>
            </div>
            <div slot="contner" class="contner">
                <slot name="contner"></slot>
            </div>
            <div slot="foter" class="foter">
                <slot name="foter"></slot>
            </div>
            
        </modalCom>
    </div>
</template>
<script>
import modalCom from '@/components/modalCom/modal'
export default {
    name:'modalreal',
    props:['zIndexEdit','width','height'],
    components:{
        modalCom
    },
    methods:{
        
        downIndex(){
            try{
            // var c=document.querySelectorAll('.shade')
            // let shade=c[c.length-1]
            // let zi=this.width?2000:1999
            // shade.style.zIndex=zi+1+''
            // var center=shade.querySelector('.center')
            // center.style.zIndex=zi+''
            }catch(e){
                console.log(e)
            }
            
        },
        upIndex(){
            try{
                if(this.width){

                }else{
            // var sahde=document.querySelector('.shade')
            // shade.style.zIndex='5999'
            // var center=shade.querySelector('.center')
            // center.style.zIndex='3000'
                }
            }catch(e){

            }
            
        }
    },
  mounted() {
    if(this.zIndexEdit){
        setTimeout(()=>{
        this.downIndex()
        },1000)
    }
  },
  destroyed(){
    if(this.zIndexEdit){
        this.upIndex()
    }
  }
}
</script>
<style  scoped>
.serch{
    position: absolute;
    top: 15px;
}
.contner{
  display: flex;
  flex-wrap: wrap;
  position: relative;
  padding-top: 15px;
  /* top: 70px; */
  width: 100%;
  /* height 505px */
  /* border-top: 1px solid #ddd; */
  /* border-bottom  1px solid #ddd */
}
.foter{
    padding-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/modalCom/modalreal.vue